document.addEventListener("DOMContentLoaded", async () => {
  const urlParts = window.location.href.split("/");
  const lastPart =
    urlParts[urlParts.length - 1] || urlParts[urlParts.length - 2];

  function convertDate(d) {
    let date = new Date(d);
    const formattedDateTime = date.toLocaleString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return formattedDateTime; // Formats to DD.MM.YYYY
  }

  function convertDateForGlobalfunction(inputDate) {
    const date = new Date(inputDate);

    // Format the date
    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0") +
      " " +
      String(date.getHours()).padStart(2, "0") +
      ":" +
      String(date.getMinutes()).padStart(2, "0") +
      ":" +
      String(date.getSeconds()).padStart(2, "0");

    return formattedDate;
  }

  function fetchSocialMediaPostsOg(size, page, source = "YOUTUBE") {
    let header_options = {
      method: "GET",
      headers: {
        Authorization: Authorization,
        Accept: "application/vnd.api+json",
      },
    };

    let top_url = `${API_URL}social-media-posts?sort=-publishedAt&page[number]=${page}&page[size]=${size}&filter[source]=${source}`;
    let res = fetch(top_url, header_options).then((res) => res.json());

    return res;
  }

  function fetchSocialMediaPostSingle(id) {
    let header_options = {
      method: "GET",
      headers: {
        Authorization: Authorization,
        Accept: "application/vnd.api+json",
      },
    };

    let top_url = `${API_URL}social-media-posts/${id}`;
    let res = fetch(top_url, header_options).then((res) => res.json());

    return res;
  }

  function generateSlideOg(res, slidePos = "top") {
    let html = "";
    resData = res.data;
    resData.forEach((data) => {
      let { id } = data;
      if (id === lastPart) return;
      let { videoUrl, imageUrl, webThumbnailUrl, mobileThumbnailUrl, title, description, publishedAt } = data.attributes[0];

      if(imageUrl == null || imageUrl == ''){
        imageUrl = defaultPlaceHolder
      }

      if(webThumbnailUrl == null || webThumbnailUrl == ''){
        webThumbnailUrl = imageUrl;
      }

      if(mobileThumbnailUrl == null || mobileThumbnailUrl == ''){
        mobileThumbnailUrl = imageUrl;
      }

      let svgPlay = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_1087" data-name="Rectangle 1087" width="100" height="100" transform="translate(-0.364 -0.103)" fill="#fff" />
            </clipPath>
          </defs>
          <g id="Group_1040" data-name="Group 1040" transform="translate(3 27.084)">
            <g id="Group_910" data-name="Group 910" transform="translate(-2.636 -26.981)" clip-path="url(#clip-path)">
              <path id="Path_643" data-name="Path 643" d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" transform="translate(-0.03 0.026)" fill="#fff" />
              <path id="Path_644" data-name="Path 644" d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" transform="translate(-1.917 -1.397)" fill="#fff" />
            </g>
          </g>
        </svg>`;

      let slide = `<div class="collage__item swiper-slide collage__item--marq_slider animate">
          <div class="collage-card card-video product-card-wrapper color-scheme-2 gradient">
            <div class="deferred-media--outer">
              <div class="deferred-media">
                <a href="${videoPageURL}/${id}" class="deferred-media__poster full-unstyled-link" aria-label="Video laden: ${title}">
                  <div class="media media--transparent ratio" style="--ratio-percent: 56.22065727699531%">
                    <img src="${webThumbnailUrl}" alt="${title}" width="" height="" class="small-hide web-thumbnail-url">
                    <img src="${mobileThumbnailUrl}" alt="${title}" width="" height="" class="medium-hide large-up-hide mobile-thumbnail-url">
                    <div class="video-heading h3">
                      ${title}
                    </div>
                  </div>
                  <div class="button_wrap button_link">
                    <div class="button button--primary">
                      Abspielen
                    </div>
                    <span class="deferred-media__poster-button motion-reduce">
                      ${svgPlay}
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>`;

      html += slide;
    });
    return html;
  }

  const curretPost = await fetchSocialMediaPostSingle(lastPart);
  //console.log("curretPost", curretPost);
  // if we have data
  if(curretPost.data){
      const { videoUrl, imageUrl, title, description, publishedAt } =
        curretPost.data.attributes[0];
      const ytId = videoUrl.split("v=")[1];
      const ytUrl = `https://www.youtube.com/embed/${ytId}?enablejsapi=1&autoplay=0&mute=0&rel=0&color=green`;
    
      // use YouTube APIs by adding iframe_api js
      var tag = document.createElement("script");
      tag.id = "script--youtube-video-iframe";
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    
      // console.log("✨");
      const iframe = document.createElement("iframe");
      iframe.setAttribute("src", ytUrl);
      iframe.setAttribute("id", "youtube-video-iframe");
      iframe.setAttribute("class", "youtube-video-iframe");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allow", "autoplay; encrypted-media");
      iframe.setAttribute("allowfullscreen", "false");
    
      document.getElementById("page_video_wrapper").appendChild(iframe);
      document.querySelector(".post-title").textContent = title;
      document.querySelector(".post-description").textContent = description;
      document.querySelector(".post-start-time").textContent = formatDate(
        convertDateForGlobalfunction(publishedAt)
      );
        
  }
  

  let player;
  window.onYouTubePlayerAPIReady = function () {
    console.log("yt ready");
    player = new YT.Player("youtube-video-iframe", {
      events: {
        onStateChange: onYTPlayerStateChange,
      },
    });
  }
  document.querySelector(".player-play-btn").addEventListener("click", () => {
    player.playVideo();
  });
  function onYTPlayerStateChange(e) {
    document.querySelector(".page-video--overlay").classList.toggle("hidden", e.data !== 2)
  }

  const allPosts = await fetchSocialMediaPostsOg(20, 1);

  // console.log("📃 allPosts", allPosts);

  const slideBottomHtml = await generateSlideOg(allPosts, "bottom");
  document.querySelector(".swiper-wrapper").innerHTML = slideBottomHtml;

  let topSlickSlider = $(
    ".section-fcsg_tv .swiper-wrapper:not(.slick-initialized)"
  ).slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><i class="icon-arrow"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="icon-arrow"></i></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    infinite: false,
    autoplaySpeed: 6000,
    speed: 800,
    // draggable: false,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          // arrows: false,
          // dots: false,
          slidesToShow: 3,
          // slidesToScroll: 3.15,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          // arrows: false,
          // dots: false,
          slidesToShow: 2.05,
          // slidesToScroll: 2.25,
        },
      },
      {
        breakpoint: 750,
        settings: {
          // arrows: false,
          // dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
